module.exports = __webpack_public_path__ + "static/media/Airbag_white.84eacc49.webp";